export const VERSION = '1.1.7'
let API_URI='https://cmapi.credentialmanagement.com.au'
let CLIENT_URL='https://portal.credentialmanagement.com.au'
let SMARTTIX_DASHBOARD='http://manage.smarttix.au'
let SMARTIX_URL='https://smarttix.au'
let members_subdomain='credentialmanagement.club'
let ENV= process.env.REACT_APP_ENV

if(ENV==='DEV'){
    API_URI='http://localhost:8001'
    CLIENT_URL='http://localhost:3000'
    SMARTTIX_DASHBOARD='http://localhost:4100'
    SMARTIX_URL='http://localhost:3000'
    members_subdomain='.test.local:3001'
}else{
    API_URI='https://cmapi.credentialmanagement.com.au'
    CLIENT_URL='https://portal.credentialmanagement.com.au'
    SMARTTIX_DASHBOARD='http://manage.smarttix.au'
    SMARTIX_URL='https://smarttix.au'
    members_subdomain='.credentialmanagement.club'
}

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''

export {
    API_URI,
    CLIENT_URL,
    SMARTTIX_DASHBOARD,
    SMARTIX_URL,
    ENV,
    members_subdomain
}